// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__XcN9M","item":"style_item__04Qsg","video":"style_video__WVeT_"};